/* eslint-disable */
import { IState } from "@/interfaces/IState";
import axios from "axios";

export const evaluation = {
    state: {
        evaluation: {},
        evaluationDetail: {},
        savingLoading: true,
        error: 0,
        answers: [],
        initializedQuiz: false,
        sessionActive: {
            medicionAsignada: 0,
            personId: 0
        },
        enablePollMobile: false,
        carouselIndex: 0,
        sentEvaluation: false,
        results: {},
        finishedQuiz: false,
        quizAvailable: true,
        currentAnswers: [],
        currentFilesFormaAsignada:[],
        currentTextFormaAsignada:[],
        currentFilesAnswers:[],
        currentTextAnswers:[],
        isLoading: false,
        isEvaluationEnded: false,
        alert: {
            status: '',
            text: ''
        },
        openAlert: false,
        assignedFormAvailable: true,
        isPreBasicAndLinkEmbebed: false,
        linkEmbebed: '',

    },
    mutations: {
        SET_EVALUATION(state: IState, payload: any) {
            state.evaluation = payload
        },
        SAVING_LOADING(state: IState, payload: any) {
            state.savingLoading = payload
        },
        SET_ERROR(state: IState, payload: any) {
            state.error = payload
        },
        SET_EVALUATION_DETAIL(state: IState, payload: any) {
            state.evaluationDetail = payload
        },
        SET_ANSWERS(state: IState, payload: any){
            state.answers = payload.answers;
        },
        SET_INITIALIZED_QUIZ(state: IState, payload: any) {
            state.initializedQuiz = payload;
        },
        SET_SESSION_ACTIVE(state: IState, payload: any) {
            state.sessionActive = payload;
        },
        ENABLE_PDF_MOBILE(state: IState, payload: any) {
            state.enablePollMobile = payload;
        },
        SET_CAROUSEL_INDEX(state: IState, payload: any) {
            state.carouselIndex = payload.carouselIndex;
        },
        SET_SENT_EVALUATION(state: IState, payload: any) {
            state.sentEvaluation = payload;
        },
        SET_RESULTS(state: IState, payload: any) {
            state.results = payload;
        },
        SET_FINISHED_QUIZ(state: IState, payload: any) {
            state.finishedQuiz = payload;
        },
        SET_QUIZ_AVAILABLE(state: IState, payload: any) {
            state.quizAvailable = payload;
        },
        SET_CURRENT_ANSWERS(state: IState, payload: any) {
            state.currentAnswers = payload;
        },
        SET_LOADING(state: IState, payload: any) {
            state.isLoading = payload;
        },
        SET_TOTAL_ANSWERED_QUESTIONS(state: IState, payload: any) {
            state.totalAnsweredQuestions = payload;
        },
        SET_ALERT(state: IState, payload: any) {
            state.alert = payload;
        },
        SET_OPEN_ALERT(state: IState, payload: any) {
            state.openAlert = payload;
        },
        SET_EVALUATION_ENDED(state: IState, payload: any) {
            state.isEvaluationEnded = payload;
        },
        SET_ASSIGNED_FORM_AVAILABLE(state: IState, payload: any) {
            state.assignedFormAvailable = payload;
        },
        SET_PREBASIC_LINK_EMBEBIDO(state: IState, payload: any) {
            state.isPreBasicAndLinkEmbebed = payload;
        },
        SET_LINK_EMBEBED(state: IState, payload: any) {
            state.linkEmbebed = payload;
        },
        SET_CURRENT_TEXT_ANSWERS(state: IState, payload: any) {
            state.currentTextAnswers= payload;
        },
        SET_CURRENT_FILES_ANSWERS(state: IState, payload: any) {
            state.currentFilesAnswers = payload;
        },
        SET_CURRENT_TEXT_FORMA_ASIGNADA(state: IState, payload: any) {
            state.currentTextFormaAsignada = payload;
        },
        SET_CURRENT_FILES_FORMA_ASIGNADA(state: IState, payload: any) {
            state.currentFilesFormaAsignada = payload;
        }
    },
    actions: {
        async setEvaluation(context: any, payload: any) {
           return  await axios
                .get(`${axios.defaults.baseURL}/evaluation?idInstitucion=${payload.idInstitucion}&idMedicionAsignada=${payload.idMedicionAsignada}&idPeriodo=${payload.idPeriodo}&idPersona=${payload.idPersona}`)
                .then(res => {
                    context.commit("SET_EVALUATION", res.data);
                    return res;
                })
                .catch(error => {
                    context.commit("SET_ERROR", 404);
                    return error.response;
                });
        },
        async setEvaluationDetail(context: any, payload: any) {
            const { formId, idInstitucion, idMedicionAsignada, idPeriodo, idPersona, id } = payload;
            const urlAPI = `${axios.defaults.baseURL}/evaluation/detail?idForma=${formId}&idInstitucion=${idInstitucion}&idMedicionAsignada=${idMedicionAsignada}&idPeriodo=${idPeriodo}&idPersona=${idPersona}`;
            return await axios.get(urlAPI)
                .then(res => {
                    context.commit("SET_EVALUATION_DETAIL", res.data);
                    return res;
                })
                .catch(error => {
                    return error;
                });
        },
        async saveEvaluation(context: any, payload: any) {
            context.commit("SAVING_LOADING", true);
            context.commit("SET_LOADING", true);
            return await axios
                .post(`${axios.defaults.baseURL}/answersRegister`, payload)
                .then(res => {
                    if(res.status === 200) {
                        context.commit("SET_EVALUATION_ENDED", false);
                        context.commit("SET_LOADING", false);

                        context.commit("SAVING_LOADING", false);
                        context.commit("SET_TIME", { time: 0 });
                        context.commit("SET_END_TIME", false);
                        context.commit("SET_SESSION_ACTIVE", { medicionAsignada: 0, personId: payload.personId });
                        context.commit("SET_OPEN_ALERT", true);
                        context.commit("SET_ALERT", { status: 'success', text: 'La evaluación se ha guardado con éxito.' });
                        context.commit("SET_SENT_EVALUATION", true);
                        context.commit("SET_QUIZ_AVAILABLE", false);
                        context.commit("SET_ASSIGNED_FORM_AVAILABLE", true);
                    }
                    return res;
                })
                .catch(error => {
                    const { data } = error.response;
                    context.commit("SET_OPEN_ALERT", true);
                    console.info("--Error al guardar la evaluacion--", error);
                    context.commit("SAVING_LOADING", false);
                    context.commit("SET_ALERT", { status: 'error', text: 'La medición asignada ha finalizado. No se puede terminar la evaluación.' });
                    context.commit("SET_SENT_EVALUATION", true);
                    context.commit("SET_QUIZ_AVAILABLE", false);
                    context.commit("SET_ASSIGNED_FORM_AVAILABLE", false);
                    return error.response
                });
        },
        async setUpdateStatusEvaluation(context: any, payload: any) {
          return  await axios.put(`${axios.defaults.baseURL}/evaluation/${payload.assignedMeasurementId}/${payload.enrollmentId}/${payload.sectionId}`, payload)
                .then(res => {
                    return res.data;
                }).catch(error => {
                  return error;
                })
        },
        async setResults(context: any, payload: any) {
          await axios.get(`${axios.defaults.baseURL}/results/${payload.i}/${payload.pi}/${payload.pdi}/${payload.ma}`)
              .then(response => {
                  context.commit("SET_RESULTS", response.data);
              })
        },
        async storeCurrentAnswers(context: any, payload: any) {
            // context.commit("SET_ALERT", { status: 'info', text: 'Guardando respuestas...' });
            context.commit("SET_LOADING", true);
            context.commit("SAVING_LOADING", true);
            return await axios.post(`${axios.defaults.baseURL}/answers/store`, payload)
                .then((res) => {
                    console.log(res);
                    
                    context.commit("SET_CURRENT_ANSWERS", payload.answerQuestionList);

                    // set this more 
                    // context.commit("SET_CURRENT_TEXT_FORMA_ASIGNADA", res.data.rptaFormaAsignada);
                    // context.commit("SET_CURRENT_FILES_FORMA_ASIGNADA", res.data.archivoFormaAsignada);

                    context.commit("SET_EVALUATION_ENDED", false);
                    context.commit("SET_LOADING", false);

                    //context.commit("SET_OPEN_ALERT", true);
                    //context.commit("SET_ALERT", { status: 'success', text: 'Las respuestas se han guardado con éxito.' });
                    context.commit("SAVING_LOADING", false);
                })
                .catch((err) => {
                    const { data } = err.response;
                    //context.commit("SET_OPEN_ALERT", true);
                    context.commit("SET_EVALUATION_ENDED", true);
                    context.commit("SET_ERROR", err);
                    //context.commit("SET_ALERT", { status: 'error', text: data.message });
                    context.commit("SET_LOADING", false);
                    context.commit("SAVING_LOADING", false);
                });
        },
        async storeInitCurrentAnswers(context: any, payload: any) {
            // context.commit("SET_ALERT", { status: 'info', text: 'Guardando respuestas...' });
            // context.commit("SET_LOADING", true);
            // context.commit("SAVING_LOADING", true);
            return await axios.post(`${axios.defaults.baseURL}/answers/store`, payload)
                .then((res) => {
                    console.log("res",res)
                    // context.commit("SET_CURRENT_ANSWERS", payload.answerQuestionList);
                    // context.commit("SET_EVALUATION_ENDED", false);
                    // context.commit("SET_OPEN_ALERT", true);
                    // context.commit("SET_ALERT", { status: 'success', text: 'Las respuestas se han guardado con éxito.' });
                    // context.commit("SET_LOADING", false);
                    // context.commit("SAVING_LOADING", false);
                })
                .catch((err) => {
                    console.log("err",err);
                    // const { data } = err.response;
                    // context.commit("SET_OPEN_ALERT", true);
                    // context.commit("SET_EVALUATION_ENDED", true);
                    // context.commit("SET_ERROR", err);
                    // context.commit("SET_ALERT", { status: 'error', text: data.message });
                    // context.commit("SET_LOADING", false);
                    // context.commit("SAVING_LOADING", false);
                });
        },
        async fetchCurrentAnswers(context: any, payload: any) {
            context.commit("SAVING_LOADING", true);
            context.commit("SET_LOADING", true);
            const { idMatricula, idMedicionAsignada, idSeccion , idForma } = payload;
            return await axios.get(`${axios.defaults.baseURL}/answers/get?idMedicionAsignada=${idMedicionAsignada}&idMatricula=${idMatricula}&idSeccion=${idSeccion}&idForma=${idForma}`)
                .then((res) => {
                    if(res.data.listAnswers === null) {
                        res.data.listAnswers = [];
                    }
                    if(res.data.rptaFormaAsignada === null) {
                        res.data.rptaFormaAsignada = [];
                    }
                    if(res.data.archivoFormaAsignada === null) {
                        res.data.archivoFormaAsignada = [];
                    }
                    if(res.data.listAnswersDesarrollo === null) {
                        res.data.listAnswersDesarrollo = [];
                    }
                    if(res.data.listAnswersArchivo === null) {
                        res.data.listAnswersArchivo = [];
                    }

                    context.commit("SET_EVALUATION_ENDED", false);

                    context.commit("SET_CURRENT_ANSWERS", res.data.listAnswers );
                    // set current text answers and current files answers
                    context.commit("SET_CURRENT_TEXT_FORMA_ASIGNADA", res.data.rptaFormaAsignada);
                    context.commit("SET_CURRENT_FILES_FORMA_ASIGNADA", res.data.archivoFormaAsignada);

                    context.commit("SET_CURRENT_TEXT_ANSWERS", res.data.listAnswersDesarrollo);
                    context.commit("SET_CURRENT_FILES_ANSWERS", res.data.listAnswersArchivo);

            
                    context.commit("SET_LOADING", false);
                    context.commit("SAVING_LOADING", false);
                    // context.commit("SET_SENT_EVALUATION", false);
                })
                .catch((err) => {
                    context.commit("SET_ERROR", err);
                    context.commit("SET_LOADING", false);
                    context.commit("SAVING_LOADING", false);
                });
        },
        setAnswers(context: any, payload: any) {
            context.commit("SET_ANSWERS", payload);
        },
        setInitializedQuiz(context: any, payload: any){
            context.commit("SET_INITIALIZED_QUIZ", payload)
        },
        resetEvaluation(context: any, payload: any) {
            context.commit("SET_EVALUATION", {});
            context.commit("SET_EVALUATION_DETAIL", payload);
            context.commit("SET_ANSWERS", {answers: [] });

            context.commit("SET_CURRENT_FILES_FORMA_ASIGNADA", []);
            context.commit("SET_CURRENT_TEXT_FORMA_ASIGNADA", []);
            
            
            context.commit("SET_CURRENT_FILES_ANSWERS", []);
            context.commit("SET_CURRENT_TEXT_ANSWERS", []);

            context.commit("SET_CURRENT_ANSWERS", []);
            context.commit("SET_INITIALIZED_QUIZ", false);
            context.commit("SET_SESSION_ACTIVE", { medicionAsignada: 0, personId: 0 });
            context.commit("SET_CAROUSEL_INDEX", { carouselIndex: 0 });
            context.commit("SET_FINISHED_QUIZ", false);
            context.commit("SET_QUIZ_AVAILABLE", true);
            context.commit("SET_OPEN_ALERT", false);
            context.commit("SET_EVALUATION_ENDED", false);
            context.commit("SET_ALERT", {});
            context.commit("SET_ERROR", null);
            context.commit("SET_LOADING", false);
            context.commit("SET_PREBASIC_LINK_EMBEBIDO", false);
            context.commit("SET_LINK_EMBEBED", '');

        },
        setSessionActive(context: any, payload: any) {
            context.commit("SET_SESSION_ACTIVE", payload)
        },
        setEnablePdfPoll(context: any, payload: any) {
            context.commit("ENABLE_PDF_MOBILE", payload);
        },
        setCarouselIndex(context: any, payload: any) {
            context.commit("SET_CAROUSEL_INDEX", payload);
        },
        setSentEvaluation(context: any, payload: any) {
            context.commit("SET_SENT_EVALUATION", payload);
        },
        setFinishedQuiz(context: any, payload: any) {
            context.commit("SET_FINISHED_QUIZ", payload);
        },
        setQuizAvailable(context: any, payload: any) {
            context.commit("SET_QUIZ_AVAILABLE", payload);
        },
        setCurrentAnswers(context: any, payload: any) {
            context.commit("SET_CURRENT_ANSWERS", payload);
        },
        setAlert(context: any, payload: any) {
            context.commit("SET_ALERT", payload);
        },
        setOperAlert(context: any, payload: any) {
            context.commit("SET_OPEN_ALERT", payload);
        },
        setAssignedFormAvailable(context: any, payload: any) {
            context.commit("SET_ASSIGNED_FORM_AVAILABLE", payload);
        },
        setIsPreBasicAndLinkEmbebed(context: any, payload: any) {
            context.commit("SET_PREBASIC_LINK_EMBEBIDO", payload);
        },
        setLinkEmbebed(context: any, payload: any) {
            context.commit("SET_LINK_EMBEBED", payload);
        },
        setCurrentTextFormaAsignada(context: any, payload: any) {
            context.commit("SET_CURRENT_TEXT_FORMA_ASIGNADA", payload);
        },
        setCurrentFilesFormaAsignada(context: any, payload: any) {
            context.commit("SET_CURRENT_FILES_FORMA_ASIGNADA", payload);
        },
        setCurrentTextAnswers(context: any, payload: any) {
            context.commit("SET_CURRENT_TEXT_ANSWERS", payload);
        },
        setCurrentFilesAnswers(context: any, payload: any) {
            context.commit("SET_CURRENT_FILES_ANSWERS", payload);
        }
    },
    getters: {
        getAnswers(state: IState) {
            return state.answers;
        },
        getEvaluation(state: IState) {
            return state.evaluation;
        },
        getEvaluationDetail(state: IState) {
            return state.evaluationDetail;
        },
        getSavingLoader(state: IState) {
            return state.savingLoading;
        },
        getInitializedQuiz(state: IState) {
            return state.initializedQuiz;
        },
        getEnablePdfPollMobile(state: IState) {
            return state.enablePollMobile;
        },
        getSessionActive(state: IState) {
            return state.sessionActive;
        },
        getCarouselIndex(state: IState){
            return state.carouselIndex;
        },
        getSentEvaluation(state: IState) {
            return state.sentEvaluation;
        },

        getResults(state: IState) {
            return state.results;
        },
        getFinishedQuiz(state: IState) {
            return state.finishedQuiz;
        },
        getQuizAvailable(state: IState) {
            return state.quizAvailable;
        },
        getCurrentAnswers(state: IState) {
            return state.currentAnswers;
        },
        getIsLoading(state: IState) {
            return state.isLoading;
        },
        getAlert(state: IState) {
            return state.alert;
        },
        getOpenAlert(state: IState) {
            return state.openAlert;
        },
        getIsEvaluationEnded(state: IState) {
            return state.isEvaluationEnded;
        },
        getAssignedFormAvailable(state: IState) {
            return state.assignedFormAvailable;
        },
        getIsPreBasicAndLinkEmbebed(state: IState) {
            return state.isPreBasicAndLinkEmbebed;
        },
        getLinkEmbebed(state: IState) {
            return state.linkEmbebed;
        },
        getCurrentTextFormaAsignada(state: IState) {
            return state.currentTextFormaAsignada;
        },
        getCurrentFilesFormaAsignada(state: IState) {
            return state.currentFilesFormaAsignada;
        },
        getCurrentTextAnswers(state: IState) {
            return state.currentTextAnswers;
        },
        getCurrentFilesAnswers(state: IState) {
            return state.currentFilesAnswers;
        }
    }
};
